<template>
  <nav id="ddmenu" :class="{ scroll: last_scroll_position > 0 }">
    <header class="wrap">
      <h1 class="logo" @click="forceRerender('/')">
        <img :src="logo" />
      </h1>
      <ul :class="{ open: mMenu }">
        <li class="mobile-nav-header">
          <div>
            <strong>{{ nickname }} </strong>
            <div class="ms-auto">
              <a
                @click="forceRerender({ path: '/login' })"
                title="Log in"
                v-if="!login"
              >
                <i class="material-icons">power_settings_new</i>
              </a>
              <router-link to="/logout" title="Log out" v-else>
                <i class="material-icons-outlined">logout</i>
              </router-link>
              <a
                @click="forceRerender({ path: '/login' })"
                title="MyZone"
                v-if="!login"
              >
                <i class="material-icons-outlined mx-2">person</i>
              </a>
              <a
                @click="forceRerender({ path: '/membership/mysummary' })"
                title="MyZone"
                v-else
              >
                <i class="material-icons-outlined mx-2">person</i>
              </a>
              <span
                @click="mmenu_on_off"
                :aria-label="$t('button.common.close')"
                title="Close"
              >
                <i class="material-icons-outlined">close</i>
              </span>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 1 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(1)"
        >
          <span class="nav-item" @mouseover="menu_on(1)">
            <b :class="{ active: menu_num === 1 }">
              {{ $t("menu.membership.membership") }}
            </b>
          </span>
          <div class="dropdown" v-if="menu === 1">
            <div class="dd-inner">
              <ul class="column">
                <li>
                  <a
                    class="more"
                    @click="forceRerender({ path: '/membership/mysummary' })"
                    :class="{ active: sub_menu_num === 11 }"
                  >
                    {{ $t("menu.membership.my_summary") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({ path: '/membership/myrecords/myrounds' })
                    "
                    :class="{ active: sub_menu_num === 12 }"
                  >
                    {{ $t("menu.membership.my_record") }}
                  </a>
                </li>
                <!-- 브랜드룸 링크 -->
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/membership/mybrandroom/fittinglist',
                      })
                    "
                    :class="{ active: sub_menu_num === 14 }"
                  >
                    {{ $t("menu.membership.my_brandroom") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/membership/myaccount/myprofile',
                      })
                    "
                    :class="{ active: sub_menu_num === 13 }"
                  >
                    {{ $t("menu.membership.my_account") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 2 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(2)"
        >
          <span class="nav-item" @mouseover="menu_on(2)">
            <b :class="{ active: menu_num === 2 }">
              {{ $t("menu.tournament.tournament") }}
            </b>
          </span>
          <div class="dropdown" v-if="menu === 2">
            <div class="dd-inner">
              <ul class="column">
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/tournament/tournamentschedule',
                      })
                    "
                    :class="{ active: sub_menu_num === 21 }"
                  >
                    {{ $t("menu.tournament.admin_tournament") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/tournament/shoptournamentschedule',
                      })
                    "
                    :class="{ active: sub_menu_num === 22 }"
                  >
                    {{ $t("menu.tournament.shop_tournament") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/tournament/jointournament',
                      })
                    "
                    :class="{ active: sub_menu_num === 23 }"
                  >
                    {{ $t("menu.tournament.tournament_information") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 3 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(3)"
        >
          <span class="nav-item" @mouseover="menu_on(3)">
            <b :class="{ active: menu_num === 3 }">{{
              $t("menu.event.event")
            }}</b>
          </span>
          <div class="dropdown" v-if="menu === 3">
            <div class="dd-inner">
              <ul class="column">
                <!-- <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/event/netizenlesson/swinglist',
                      })
                    "
                    :class="{ active: sub_menu_num === 31 }"
                  >
                    {{ $t("menu.event.netizen_lesson") }}
                  </a>
                </li> -->
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/event/minigame',
                      })
                    "
                    :class="{ active: sub_menu_num === 32 }"
                  >
                    {{ $t("menu.event.minigame") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/event/winaminigame',
                      })
                    "
                    :class="{ active: sub_menu_num === 33 }"
                  >
                    {{ $t("menu.event.minigame_winners") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/event/joinminigame',
                      })
                    "
                    :class="{ active: sub_menu_num === 34 }"
                  >
                    {{ $t("menu.event.minigame_informaition") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 4 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(4)"
        >
          <span class="nav-item" @mouseover="menu_on(4)">
            <b :class="{ active: menu_num === 4 }">
              {{ $t("menu.golfcourse.golfcourse") }}
            </b>
          </span>
          <div class="dropdown" v-if="menu === 4">
            <div class="dd-inner">
              <ul class="column">
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/golfcourse/courselist',
                      })
                    "
                    :class="{ active: sub_menu_num === 41 }"
                  >
                    {{ $t("menu.golfcourse.golfcourse") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 5 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(5)"
        >
          <span class="nav-item" @mouseover="menu_on(5)">
            <b :class="{ active: menu_num === 5 }">
              {{ $t("menu.find_location.find_location") }}
            </b>
          </span>
          <div class="dropdown" v-if="menu === 5">
            <div class="dd-inner">
              <ul class="column">
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/findlocation/stores',
                      })
                    "
                    :class="{ active: sub_menu_num === 51 }"
                  >
                    {{ $t("menu.find_location.find_location") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li
          :class="{ over: menu === 6 }"
          @mouseleave="menu_off()"
          @click="menu_on_m(6)"
        >
          <span class="nav-item" @mouseover="menu_on(6)">
            <b :class="{ active: menu_num === 6 }">{{
              $t("menu.support.support")
            }}</b>
          </span>
          <div class="dropdown" v-if="menu === 6">
            <div class="dd-inner">
              <ul class="column">
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/support/notice',
                      })
                    "
                    :class="{ active: sub_menu_num === 61 }"
                    >{{ $t("menu.support.notice") }}</a
                  >
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/support/inquiry',
                      })
                    "
                    :class="{ active: sub_menu_num === 62 }"
                  >
                    {{ $t("menu.support.inquiry") }}
                  </a>
                </li>
                <li>
                  <a
                    class="more"
                    @click="
                      forceRerender({
                        path: '/support/resources',
                      })
                    "
                    :class="{ active: sub_menu_num === 63 }"
                  >
                    {{ $t("menu.support.resources") }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </li>
      </ul>

      <div
        class="header-utility justify-content-lg-between justify-content-xl-end"
        v-if="!login"
      >
        <a
          @click="
            forceRerender({
              path: '/login',
            })
          "
          title="Log in"
          class="d-none d-lg-inline-block"
        >
          <i class="material-icons">power_settings_new</i>
          <span>{{ $t("menu.login.login") }}</span>
        </a>
        <router-link
          to="/login"
          class="d-none d-lg-inline-block ms-0 ms-xl-2"
          title="MyZone"
        >
          <i class="material-icons-outlined">person</i>
          <span>{{ $t("menu.login.my_zone") }}</span>
        </router-link>
        <div
          class="d-xl-none hamburger-menu-wraper"
          :class="[{ 'menu-icon-active': mMenu }]"
          @click="mmenu_on_off()"
          title="Navigation menu"
        >
          <span class="hamburger-icon" aria-label="Navigation menu">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>

      <div
        class="header-utility justify-content-lg-between justify-content-xl-end"
        v-else
      >
        <router-link
          to="/logout"
          title="Log out"
          class="d-none d-lg-inline-block"
        >
          <i class="material-icons-outlined">logout</i>
          <span>{{ $t("menu.login.logout") }}</span>
        </router-link>
        <a
          @click="
            forceRerender({
              path: '/membership/mysummary',
            })
          "
          class="d-none d-lg-inline-block ms-0 ms-xl-2"
          title="MyZone"
        >
          <i class="material-icons-outlined">person</i>
          <span>{{ $t("menu.login.my_zone") }}</span>
        </a>
        <div
          class="d-xl-none hamburger-menu-wraper"
          :class="[{ 'menu-icon-active': mMenu }]"
          @click="mmenu_on_off()"
          title="Navigation menu"
        >
          <span class="hamburger-icon" aria-label="Navigation menu">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>
      </div>
      <!-- 게임로그인 버튼 -->
      <b-button variant="game-login" @click="participation">
        {{ $t("button.common.game_login") }}
      </b-button>
      <b-toast
        id="toast-require-login"
        toaster="position-fixed top-50 start-50 translate-middle"
        no-close-button
        no-auto-hide
        solid
        body-class="p-4 text-center"
      >
        <div class="avatar avatar-xl mt-2 bg-orange border-0">
          <span class="material-icons default-icon-profile text-white"
            >person</span
          >
        </div>
        <h6 class="sub-title mt-3 mb-2">
          {{ $t("text.common.require_login") }}
        </h6>
        <p class="pt-1">{{ $t("text.common.go_login_page") }}</p>
        <div class="btn-bottom-wrapper mt-3">
          <b-button
            size="sm"
            variant="outline-secondary"
            :aria-label="$t('button.common.cancel')"
            @click="$bvToast.hide('toast-require-login')"
          >
            {{ $t("button.common.cancel") }}
          </b-button>
          <b-button
            size="sm"
            variant="secondary"
            :aria-label="$t('button.common.login')"
            @click="
              $router.push('/Login');
              $bvToast.hide('toast-require-login');
            "
          >
            {{ $t("button.common.login") }}
          </b-button>
        </div>
      </b-toast>

      <b-modal
        id="modal-game-login"
        centered
        scrollable
        dialog-class="modal-fullscreen-sm-down"
        header-class="pt-5 pb-4"
        body-class="d-flex flex-column"
        footer-class="btn-bottom-wrapper py-4 border-0"
      >
        <template #modal-header>
          <h3 class="flex-fill text-center">
            {{ $t("text.common.game_login") }}
          </h3>
          <b-button
            variant="close"
            :aria-label="$t('button.common.close')"
            @click="$bvModal.hide('modal-game-login')"
          >
          </b-button>
        </template>

        <template>
          <!-- Step1 -->
          <div
            class="game-login-step1 d-flex flex-column align-items-center"
            v-if="game_login_stpe == 1"
          >
            <div class="avatar avatar-xxxl my-3">
              <img v-if="member_img" :src="member_img | get_img" />
              <span v-else class="material-icons default-icon-profile"
                >person</span
              >
            </div>

            <div class="text-center text-black">
              <p class="mb-2 lh-sm text-capitalize">
                <strong>{{ nickname }}</strong
                >님 {{ $t("text.common.welcome") }}
              </p>
              <h5
                class="lh-sm fw-500"
                v-html="$t('text.common.enter_verification_number')"
              ></h5>
            </div>

            <div class="row gx-2 verify-number-wrapper">
              <div class="col" v-for="(digit, idx) in 5" :key="idx">
                <input
                  type="text"
                  maxlength="1"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  placeholder="*"
                  v-model="code[idx]"
                  :ref="'codeInput' + idx"
                  @input="onInputMoveFocus(idx, $event)"
                  @keydown.backspace="onBackspaceMoveFocus(idx, $event)"
                />
              </div>
            </div>

            <p
              v-if="game_login_flag == 1"
              class="text-subscript text-center text-success"
              v-html="$t('text.common.verification_number_match')"
            ></p>
            <p
              v-if="game_login_flag == 2"
              class="text-subscript text-center text-danger"
              v-html="game_login_message"
            ></p>

            <p
              v-if="game_login_flag == 3"
              class="text-subscript text-center text-danger"
            >
              이미 등록된 회원입니다.
              <b-button
                size="sm"
                variant="outline-secondary"
                @click="delete_registration"
              >
                등록 삭제
              </b-button>
            </p>
          </div>
          <!-- // Step1 -->

          <!-- Step2 -->
          <div
            class="game-login-step2 vstack gap-3"
            v-if="game_login_stpe == 2"
          >
            <!-- Tournament -->
            <div
              class="card border-0"
              v-if="Object.keys(tournamentinfo).length !== 0"
            >
              <div class="card-body d-flex p-0">
                <div class="vstack p-4 w-auto border">
                  <div
                    class="align-self-start icon badge text-capitalize bg-black"
                  >
                    {{ tournament_type(tournamentinfo.type) }}
                    <!-- {{ $t("title.main.tournament") }}<small class="vr"></small
                    >{{ $t("text.common.status_public") }} -->
                  </div>
                  <h5 class="card-title m-0">{{ tournamentinfo.title }}</h5>
                  <p class="fs-14 text-date">
                    <!-- 서비스 시간 -->
                    {{
                      tournamentinfo.timezone_startdate &&
                      tournamentinfo.timezone_startdate.timezone_common
                        | dateformat("YYYY.MM.DD")
                    }}
                    ~
                    {{
                      tournamentinfo.timezone_startdate &&
                      tournamentinfo.timezone_enddate.timezone_common
                        | dateformat("YYYY.MM.DD")
                    }}
                  </p>
                  <!-- <p class="text-subscript text-info">
                    {{ $t("text.common.tournament_entry_requirements") }}
                  </p> -->
                  <p class="text-subscript text-danger">
                    대회 최대 참가 제한 횟수 {{ tournamentinfo.entrycnt }}/{{
                      tournamentinfo.entrylimit | transToValue("∞")
                    }}
                    를 완료했습니다.
                  </p>
                </div>
                <div
                  class="card-footer d-flex justify-content-center mt-0 border fs-12"
                >
                  <div class="d-flex flex-column justify-content-center mt-0">
                    <div class="text-center">
                      <input
                        class="mx-0 mb-2"
                        type="checkbox"
                        id="CheckApply"
                        v-model="tour_flag"
                      /><br />
                      <!-- <label class="text-nowrap text-black" for="CheckApply">{{
                        $t("text.common.participation")
                      }}</label> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- // Tournament -->
            <!-- Event -->
            <div
              class="card border-0"
              v-if="Object.keys(eventinfo).length !== 0"
            >
              <div class="card-body d-flex p-0">
                <div class="vstack p-4 w-auto border">
                  <div
                    class="align-self-start icon badge text-capitalize bg-pink"
                  >
                    {{ event_type(eventinfo.type) }}
                  </div>
                  <h5 class="card-title m-0">{{ eventinfo.title }}</h5>
                  <p class="fs-14 text-date">
                    {{
                      eventinfo.timezone_startdate &&
                      eventinfo.timezone_startdate.timezone_common | dateformat
                    }}
                    ~
                    {{
                      eventinfo.timezone_enddate &&
                      eventinfo.timezone_enddate.timezone_common | dateformat
                    }}
                  </p>
                  <p class="text-subscript text-danger">
                    대회 최대 참가 제한 횟수 {{ eventinfo.entrycnt }}/{{
                      eventinfo.entrylimit | transToValue("∞")
                    }}
                    를 완료했습니다.
                  </p>
                </div>
                <div
                  class="card-footer d-flex justify-content-center mt-0 border fs-12"
                >
                  <div class="d-flex flex-column justify-content-center mt-0">
                    <div class="text-center">
                      <input
                        class="mx-0 mb-2"
                        type="checkbox"
                        id="CheckApply"
                        v-model="award_flag"
                      /><br />
                      <label class="text-nowrap text-black" for="CheckApply">{{
                        $t("text.common.participation")
                      }}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- // Event -->
          </div>
          <!-- // Step2 -->
        </template>

        <template #modal-footer>
          <b-button
            size="md"
            variant="outline-secondary"
            :aria-label="$t('button.common.cancel')"
            @click="$bvModal.hide('modal-game-login')"
          >
            {{ $t("button.common.cancel") }}
          </b-button>
          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.confirm')"
            @click="postGameCode()"
            v-if="game_login_stpe == 1"
          >
            {{ $t("button.common.confirm") }}
          </b-button>

          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.confirm')"
            @click="post_insertGameCode()"
            v-if="game_login_stpe == 2"
          >
            {{ $t("button.common.confirm") }}
          </b-button>
        </template>
      </b-modal>

      <b-modal
        id="modal-sign-up"
        visible
        centered
        scrollable
        header-class="pb-3 border-0"
        body-class="pt-0 text-center"
        footer-class="btn-bottom-wrapper p-md-4 border-0"
        v-if="!login && $route.path === '/'"
      >
        <template #modal-header>
          <b-button
            variant="close ms-auto"
            :aria-label="$t('button.common.close')"
            @click="$bvModal.hide('modal-sign-up')"
          >
          </b-button>
        </template>

        <template>
          <!-- <img class="col-5 col-sm-4" src="/img/logo_black.png"> -->
          <h4 class="mb-3">
            {{ $t("text.common.membership_benefits") }}
          </h4>
          <p
            class="mb-3 mb-sm-4 lh-sm text-center text-primary text-opacity-75"
            v-html="$t('text.common.membership_benefits_expl')"
          ></p>

          <div class="row gx-0 gy-2 gy-sm-3 px-sm-5">
            <div class="d-flex align-items-center rounded-pill bg-gray">
              <div class="mx-3">
                <div class="avatar avatar-xl bg-green border-0">
                  <span class="material-icons default-icon text-white"
                    >insights</span
                  >
                </div>
              </div>
              <div class="py-3 text-start">
                <p class="fw-500 lh-base text-black">
                  {{ $t("text.common.customized_benefits") }}
                </p>
                <p
                  class="fs-14 lh-sm"
                  v-html="$t('text.common.customized_benefits_expl')"
                ></p>
              </div>
            </div>

            <div class="d-flex align-items-center rounded-pill bg-gray">
              <div class="mx-3">
                <div class="avatar avatar-xl bg-black border-0">
                  <span class="material-icons default-icon text-white"
                    >emoji_events</span
                  >
                </div>
              </div>
              <div class="py-3 text-start">
                <p class="fw-500 lh-base text-black">
                  {{ $t("text.common.tournament") }}
                </p>
                <p
                  class="fs-14 lh-sm"
                  v-html="$t('text.common.tournament_expl')"
                ></p>
              </div>
            </div>

            <div class="d-flex align-items-center rounded-pill bg-gray">
              <div class="mx-3">
                <div class="avatar avatar-xl bg-pink border-0">
                  <span class="material-icons default-icon text-white"
                    >golf_course</span
                  >
                </div>
              </div>
              <div class="py-3 text-start">
                <p class="fw-500 lh-base text-black">
                  {{ $t("text.common.mini_game") }}
                </p>
                <p
                  class="fs-14 lh-sm"
                  v-html="$t('text.common.mini_game_expl')"
                ></p>
              </div>
            </div>
          </div>
        </template>

        <template #modal-footer>
          <b-button
            size="md"
            variant="outline-secondary"
            :aria-label="$t('button.common.login')"
            @click="
              $router.push('/Login');
              $bvModal.hide('modal-sign-up');
            "
          >
            {{ $t("button.common.login") }}
          </b-button>
          <b-button
            size="md"
            variant="secondary"
            :aria-label="$t('button.common.sign_up')"
            @click="
              $router.push({ name: 'SignUp' });
              $bvModal.hide('modal-sign-up');
            "
          >
            {{ $t("button.common.sign_up") }}
          </b-button>
        </template>
      </b-modal>
    </header>
  </nav>
</template>

<script>
import Footer from "./Footer.vue";
import ax from "@/api/auth";
import { myMixin } from "@/mixin/myMixin";

export default {
  components: { Footer },
  name: "Header",
  data() {
    return {
      menu: 0,
      mMenu: false,
      is_mobile: false,
      login: sessionStorage.getItem("token") ? true : false,
      last_scroll_position: 0,
      nickname: sessionStorage.getItem("nickname") || "",
      member_img: "",

      code: ["", "", "", "", ""],
      tournamentinfo: {},
      eventinfo: {},
      game_login_stpe: 1,
      game_login_flag: 0,
      players_pk: 0,
      game_login_message: "",
      tour_flag: 0,
      award_flag: 0,
    };
  },
  methods: {
    onInputMoveFocus(idx, e) {
      const val = e.target.value.replace(/[^0-9]/g, "");
      this.$set(this.code, idx, val); // Vue 2 반응성 보장

      if (val && idx < this.code.length - 1) {
        this.$nextTick(() => {
          let nextInput = this.$refs["codeInput" + (idx + 1)];

          // 배열이면 첫 번째 요소 꺼내기
          if (Array.isArray(nextInput)) {
            nextInput = nextInput[0];
          }

          if (nextInput && nextInput.focus) {
            nextInput.focus();
          }
        });
      }
    },
    onBackspaceMoveFocus(idx, e) {
      if (!e.target.value && idx > 0) {
        this.$nextTick(() => {
          let prevInput = this.$refs["codeInput" + (idx - 1)];

          if (Array.isArray(prevInput)) {
            prevInput = prevInput[0];
          }

          if (prevInput && typeof prevInput.focus === "function") {
            prevInput.focus();
          } else {
            console.warn("❌ 이전 input 포커스 실패", prevInput);
          }
        });
      }
    },
    getVerifyCode() {
      return this.code.join("");
    },
    participation() {
      if (!this.login) {
        this.$bvToast.show("toast-require-login");
        return false;
      }
      ax.get_gamelogininfo((flag, data) => {
        if (flag) {
          if (data && data.playerbasicinfo) {
            this.member_img = data.playerbasicinfo.member_photo_url;
            this.game_login_stpe = 1;
            this.game_login_flag = 0;
            this.code = ["", "", "", "", ""];

            if (data.already_registered) {
              this.game_login_flag = 3;
              this.players_pk = data.players_pk;
              this.code =
                data.loginid.length === 5
                  ? data.loginid.split("")
                  : ["", "", "", "", ""];
            }
            this.$bvModal.show("modal-game-login");
          }
        }
      });
    },

    postGameCode() {
      if (this.getVerifyCode() == "") {
        alert("인증번호를 입력해 주세요");
        return false;
      }
      ax.postGameCode({ gamecode: this.getVerifyCode() }, (flag, data) => {
        // console.log(flag, data);
        if (flag) {
          if (
            data &&
            Array.isArray(data.tournamentlist) &&
            data.tournamentlist.length > 0 &&
            data.tournamentlist[0].tournamentinfo
          ) {
            this.tournamentinfo = data.tournamentlist[0].tournamentinfo;
          } else {
            this.tournamentinfo = {}; // 또는 {} 등 기본값
          }

          if (
            data &&
            Array.isArray(data.awardrulelist) &&
            data.awardrulelist.length > 0 &&
            data.awardrulelist[0]
          ) {
            this.eventinfo = data.awardrulelist[0];
          } else {
            this.eventinfo = {}; // 또는 {} 등 기본값
          }
          if (
            Object.keys(this.tournamentinfo).length === 0 &&
            Object.keys(this.eventinfo).length === 0
          ) {
            this.post_insertGameCode();
          } else {
            this.game_login_stpe = 2;
            this.tour_flag = false;
            this.award_flag = false;
          }
          // this.$bvModal.show("modal-game-login");
        } else {
          this.game_login_message = data.message;
          this.code = ["", "", "", "", ""];
          // alert(data.message);
          this.game_login_flag = 2;
        }
      });
    },

    post_insertGameCode() {
      ax.post_insertgamecode(
        {
          gamecode: this.getVerifyCode(),
          tour_pk: this.tournamentinfo.tournamentno,
          award_pk: this.eventinfo.rule_pk,
          tour_flag: this.tour_flag,
          award_flag: this.award_flag,
        },
        (flag, data) => {
          // console.log(flag, data);

          if (flag) {
            this.$bvModal.hide("modal-game-login");
            alert(data.message);
          } else {
            this.game_login_message = data.message;
            this.game_login_stpe = 1;
            this.game_login_flag = 2;
          }
        }
      );
    },
    delete_registration() {
      ax.delete_registration(this.players_pk, (flag, data) => {
        // console.log(flag, data);

        if (flag) {
          this.game_login_message = data.message;
          this.game_login_stpe = 1;
          this.game_login_flag = 2;
          this.code = ["", "", "", "", ""];
        } else {
          alert(data.message);
        }
      });
    },
    forceRerender: function (val) {
      if (window.innerWidth < 1000) {
        this.mMenu = false;
      }

      this.$store.commit("setSearchData", {});
      this.$store.commit("forceRerender");
      this.$router.push(val).catch(() => {});
    },
    menu_on: function (eq) {
      if (this.is_mobile) return;
      this.menu = eq;
    },
    menu_on_m: function (eq) {
      if (!this.is_mobile) return;
      if (this.menu === eq) this.menu = 0;
      else this.menu = eq;
    },
    menu_off: function () {
      if (this.is_mobile) return;
      this.menu = 0;
    },
    mmenu_on_off: function () {
      if (this.mMenu === false) {
        this.menu = this.menu_num;
        this.mMenu = true;
      } else this.mMenu = false;
    },
    check_mobile: function () {
      let filter = "win16|win32|win64|mac|macintel";
      if (navigator.platform) {
        if (filter.indexOf(navigator.platform.toLowerCase()) < 0) {
          this.is_mobile = true;
        } else {
          this.is_mobile = false;
        }
      }
    },
    onScroll: function () {
      const currentScrollPosition =
        window.pageYOffset || document.documentElement.scrollTop;
      if (currentScrollPosition < 0) {
        return;
      }
      this.last_scroll_position = currentScrollPosition;
    },
    check_store: function () {
      if (sessionStorage.getItem("token")) {
        this.$store.dispatch("check_login");
      }
    },
    widthCheck() {
      // if (window.innerWidth < 1000) {
      //   this.icon_visible = false;
      // } else {
      //   this.icon_visible = true;
      // }
    },
    handleResize(event) {
      // if (window.innerWidth < 1000) {
      //   this.icon_visible = false;
      // } else {
      //   this.icon_visible = true;
      // }
    },
    resizeEvent() {
      // window.addEventListener("resize", this.handleResize);
    },
  },
  mounted() {
    if (this.$store.state.status === "success") {
      this.login = true;
    }
    window.addEventListener("scroll", this.onScroll);
    this.resizeEvent();
  },
  beforeDestroy() {
    this.resizeEvent();
  },
  created() {
    this.check_mobile();
    this.check_store();
    this.widthCheck();
  },
  watch: {
    "$store.state.status": function () {
      this.login = this.$store.state.status === "success" ? true : false;
      this.nickname = sessionStorage.getItem("nickname") || "";
    },

    "$route.name": function () {
      this.mMenu = false;
    },
    "$route.meta.menu_num": function () {
      this.memu = this.$route.meta.menu_num;
    },
  },
  computed: {
    logo: function () {
      if (
        this.$route.name === "Login" ||
        this.$route.name === "Find_Id_Pwd" ||
        this.$route.name === "Terms" ||
        this.$route.name === "Privacy" ||
        this.$route.name === "ConfirmPassword" ||
        this.last_scroll_position > 0
      )
        return "/img/logo_black.png";
      else return "/img/logo_white.png";
    },
    menu_num: function () {
      return this.$route.meta.menu_num || "";
    },
    sub_menu_num: function () {
      return this.$route.meta.sub_menu_num || "";
    },
  },
  mixins: [myMixin],
};
</script>
